import { Flex, Pagination } from "@mantine/core";

export default function RoutePagination({ page = 1, total = 1, setSearchParams }) {
  return (
    <Flex justify="flex-end" mt="md">
      <Pagination
        total={total}
        size="sm"
        value={page ? Number(page) : 1}
        onChange={(page) =>
          setSearchParams((prev) => {
            prev.set("page", page);
            return prev;
          })
        }
      />
    </Flex>
  );
}
